<template>
  <div class="px-3 py-2" style="margin-top: 75px;">
    <b-row>
      <b-col
          cols="12"
          style="
         margin-left: 0px;
         margin-right: 0px;"
      >
      <side-main
        :session="session"
        :profile="profile"
        :room-data="roomData"
        :av-resources="avResources"
        @add-data-click="handleAddDataButtonClick"
      />
      </b-col>
    </b-row>
    <b-row style="margin-top: 10px; color:#EBC8A9FF">
      <b-col>
        <h3>{{ sessionTitle }}</h3>
        <h6> {{ sessionTopic }}</h6>
      </b-col>
    </b-row>
    <hr />
    <b-row style="margin-top: 10px; color:#EBC8A9FF">
      <b-col>
        <tip-tap-output
            v-if="sessionDescription && Array.isArray(sessionDescription)"
            :content="sessionDescription"
            :show-less-char="300"
            :use-dots="true"
        />
      </b-col>
    </b-row>
    <hr />
    <b-row
        v-if="roomData.role == 'admin'"
        style="margin: 35px; color:#EBC8A9FF"
      >
      <b-col style="background-color: black; border-radius: 15px;">
        <ul>
          <li>On-Stage: Speaker- Drop Down</li>
          <li>Block Users</li>
          <li>Show Count Down</li>
        </ul>

        Show Title Running Scroll of people Coming in
        <b-iconstack id="p_settings_control"  :font-scale="2"
                     style="cursor:pointer; margin: 5px">
          <b-icon stacked icon="circle-fill"
                  variant="dark"/>
          <b-icon stacked icon="gear"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
                  rotate="130"
          />
        </b-iconstack>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <side-right
            :session="session"
            :profile="profile"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SideMain from "./sideMain";
import SideRight from "./sideRight"; //@ToDo- Change Name
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "Sessions_Sidebar_Session_View",
  components: {
    SideMain,
    SideRight,
    TipTapOutput
  },
  props: {
    session: {
      type: Object,
      default: () => {
        return {}
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    roomData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    avResources: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  mounted() {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleAddDataButtonClick() {
      this.$emit('add-data-click', this.session);
    }
  },
  data() {
    return {
      sessionTitle: this.session && this.session.session &&
      this.session.session.title ? this.session.session.title : 'Title Error',
      sessionTopic: this.session && this.session.session  &&
      this.session.session.topic ? this.session.session.topic : '',
      sessionDescription: this.session && this.session.session  &&
      this.session.session.description ? this.session.session.description : '',
      mainPropsLogo: { blank: false, blankColor: '#777', class: 'm1' },
      theme:this.session && this.session.session &&
      this.session.session.theme ? this.session.session.theme : null,
    };
  }
};
</script>

<style lang="scss" scoped>
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
